import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, map } from 'rxjs';
import { ModalService } from 'src/app/app-modals/services/modal.service';
import { DPCompany } from 'src/app/core/models/DPCompany';
import { AccountService } from 'src/app/core/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { HooksService } from 'src/app/core/services/hooks.service';
import { LayoutService } from 'src/app/core/services/layout.service';
import { PwaService } from 'src/app/core/services/pwa.service';

/**
 * App Topbar component.
 */
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, OnDestroy {
  @ViewChild('profileDropdown') profileDropdown: NgbDropdown;

  username: string = '';
  companyInfo: DPCompany;
  isDashboard = false;
  profileMenuAutoClose$ = this.layoutService.forceProfileMenuOpen$.pipe(
    map((forceOpen) => !forceOpen)
  );

  private subscriptions: Subscription[] = [];
  private logoutSub: Subscription;

  constructor(
    public auth: AuthService,
    public pwa: PwaService,
    public account: AccountService,
    private hooks: HooksService,
    private companyService: CompanyService,
    private modalService: ModalService,
    private layoutService: LayoutService,
    private router: Router
  ) {
    this.subscriptions.push(
      this.companyService.info.subscribe((info: DPCompany) => {
        this.companyInfo = info;
      }),
      this.router.events.subscribe((ev) => {
        /**
         * Check whether current page is dashboard page or not.
         * This value is used to show Quick Tour button in the profile menu.
         */
        if (ev instanceof NavigationEnd) {
          if (ev.url.includes('/dashboard')) {
            this.isDashboard = true;
          } else {
            this.isDashboard = false;
          }
        }
      })
    );
    this.account.fetchAvatar();
  }

  ngOnInit() {
    this.auth.isAuthenticated$.subscribe((authenticated) => {
      if (authenticated) {
        this.username = this.auth.userName;
      }
    });

    this.layoutService.triggerProfileMenuOpen$.subscribe({
      next: (open) => {
        if (open) {
          this.profileDropdown.open();
        } else {
          this.profileDropdown.close();
        }
      },
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
    this.logoutSub?.unsubscribe();
  }

  /**
   * Logout the user
   */
  logout() {
    this.logoutSub?.unsubscribe();

    /**
     * Wait until all "logout" hooks emit true and logout.
     */
    this.logoutSub = this.hooks.subscribeToHook('logout', () => {
      this.auth.logout();
    });
  }

  /**
   * Install Angular app as PWA.
   */
  install() {
    this.pwa.install();
  }

  /**
   * Show Quick tour in Dashboard page.
   */
  showQuickTour() {
    if (this.isDashboard) {
      this.hooks.callHook('guided-tour');
    }
  }

  /**
   * Show feedback modal.
   */
  openHelp() {
    this.modalService.showHelpModal({});
  }
}
